import { get } from "../methods";
function getUserCompanyPeers_default({ companyId }, headers = {}) {
  const config = {
    url: `backend/company-peers/user/peers/${companyId.toLowerCase()}`,
    headers
  };
  return get(config);
}
export {
  getUserCompanyPeers_default as default
};
